// extracted by mini-css-extract-plugin
export default {"divSearch":"SearchBar_divSearch__K3EcR","barra":"SearchBar_barra__EWtJm","boton":"SearchBar_boton__CVvIJ","shake":"SearchBar_shake__YKgO7"};